import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as R from 'ramda'
import { megaBytesToBytes, fileToBase64, alertSizeOverLimit } from 'libs/file'
import { Button } from '@material-ui/core'
import clsx from 'clsx'
import { compressImage } from 'libs/compressImage'
import { useIntl, FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'

const useStyle = makeStyles((theme) => ({
  secondary: {
    color: theme.palette.secondary.main,
  },
}))

const resizeImage = (onChange) => async (file) => {
  const newFile = await compressImage(file)
  return R.unless(R.isNil, onChange)(newFile)
}

// size in bytes
const PHOTO_SIZE_LIMIT = megaBytesToBytes(10)

const MembershipCardAvatar = ({ avatar, onAvatarSelect, alt }) => {
  const classes = useStyle()

  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const [randomName] = useState(Math.random())

  const handleUploadAvatar = R.ifElse(
    R.propSatisfies(R.lt(R.__, PHOTO_SIZE_LIMIT), 'size'),
    (file) => {
      fileToBase64(file).then((fileData) => onAvatarSelect(fileData))
    },
    () => {
      alertSizeOverLimit(dispatch, formatMessage, PHOTO_SIZE_LIMIT)
    },
  )

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-full">
        <img alt={alt} className="relative w-full rounded-8" src={avatar} />
      </div>
      <Button
        className={clsx('mt-12 py-4 px-5 cursor-pointer', classes.secondary)}
        component="label"
        htmlFor={randomName}
      >
        <FormattedMessage id="membershipCard.form.changePhoto" />
      </Button>
      <input
        type="file"
        id={randomName}
        accept="image/png, image/jpeg"
        className="invisible absolute"
        onChange={R.compose(
          R.ifElse(R.isNil, R.identity, resizeImage(handleUploadAvatar)),
          R.unless(R.isNil, R.head),
          R.view(R.lensPath(['target', 'files'])),
        )}
      />
    </div>
  )
}

export default MembershipCardAvatar
